/**
 * 用户模块
 */
import { request } from '@/apis/http';
import queryString from 'query-string';
import {
  DoLoginReq,
  SysUserAddReq,
  SysUserInfoALlUpdateReq,
  SysUserInfoVo,
  SysUserUpdateReq,
  UpdatePassWordReq,
} from 'typings/openapi';
import {
  GetLoginInfoResponse,
  PostDoLoginRequest,
  PostDoLoginResponse,
  QuerySysRoleResponse,
  QueryUserRequest,
} from './types';

/**
 * 登录
 */
export const PostDoLogin = (data: PostDoLoginRequest) => {
  const target = queryString.parseUrl(location.href).query.target as string | undefined;
  const prefix = target ? target : location.host.split('.')?.[0];
  let loginReq: DoLoginReq = {
    platformType: data.platformType as DoLoginReq.platformType,
    accountId: data.accountId,
    password: data.password,
    loginType: data.status,
    identifier: prefix,
    identifierType: '1',
    ...data,
  };
  return request<PostDoLoginResponse>('/user/doLogin/pc', { method: 'POST', data: loginReq });
};

/**
 * 获取登录用户的信息
 */
export const GetLoginInfo = () => {
  return request<GetLoginInfoResponse>('/user/getUserInfo');
};

/**
 * 获取用户列表 | 查询用户基本信息
 */
export const QueryUsers = (data: QueryUserRequest) => {
  return request<PagingResponse<SysUserInfoVo>>('/user/queryList', { params: data });
};

/**
 * 新增用户
 * @param {string} id 用户id
 * @param {SysUserAddReq} data 用户信息
 *  */
export const CreateUser = (data: SysUserAddReq) => {
  return request('/user/add', { method: 'POST', data });
};

/**
 * 修改用户
 * @param {string} id 用户id
 * @param {SysUserAddReq} data 用户信息
 *  */
export const UpdateUser = (id: string, data: SysUserAddReq) => {
  return request(`/user/update/${id}`, { method: 'POST', data });
};

/**
 * 批量修改用户， 启动删除等
 */
export const BatchUpdateUser = (data: SysUserUpdateReq) => {
  return request('/user/batchUpdateUser', {
    method: 'POST',
    data: data,
  });
};

/**
 * 全量修改用户， 启动删除等
 */
export const AllUpdateUser = (data: SysUserInfoALlUpdateReq) => {
  return request('/user/allUpdate', {
    method: 'POST',
    data: data,
  });
};

/** 获取当前登录人角色列表 */
export const QuerySysRole = () => {
  return request<QuerySysRoleResponse[]>('/user/querySysRole', {
    method: 'GET',
  });
};

/** 用户修改密码 */
export const UpdateUserPassword = (data: UpdatePassWordReq) => {
  return request('/user/updatePsw', {
    method: 'POST',
    data: data,
  });
};
